import React, { useState } from "react";
import {Route, Switch,useLocation } from "react-router-dom";
import {AnimatePresence} from "framer-motion";
import Home from "./components/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PersonalInfo from "./components/PersonalInfo";
import EducationDetails from "./components/EducationDetails";
import Interests from "./components/Interests";
import Intro from "./components/Intro";
import LangKnown from "./components/LangKnown";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import WorkExp from "./components/WorkExp";
import Preview from "./components/Preview";
import AddInfos from "./components/AddInfos";
import Templates from './components/Templates'
import PreviewTemplate from './components/PreviewTemplate'
import PageNotFound from './components/PageNotFound'


function App() {
  const location=useLocation();
  return (
    <div className="App">
      <Header />
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.key} >
          <Route path="/" exact component={Home} />
          <Route path="/personal-info">
            <PersonalInfo/>
          </Route>
          <Route path="/education-details">                                                                       
            <EducationDetails/>
          </Route>
          <Route path="/add-skills">                                                                              
            <Skills/>
          </Route>
          <Route path="/add-languages">                                                                           
            <LangKnown/>
          </Route>
          <Route path="/add-work-experience">                                                                                   
            <WorkExp/>
          </Route>
          <Route path="/add-project-details">                                                                                   
            <Projects/>
          </Route>
          <Route path="/add-interests">                                                                                   
            <Interests/>
          </Route>
          <Route path="/introduction">                                                                                   
            <Intro/>
          </Route>
          <Route path="/preview-details">                                                                                   
            <Preview/>
          </Route>
          <Route path="/additional-details">                                                                                   
            <AddInfos/>
          </Route>
          <Route path="/choose-resume-template">                                                                                   
            <Templates/>
          </Route>  
          <Route path="/preview-template/:id" exact component={PreviewTemplate} />                                                                                   
          <Route path="*" component={PageNotFound} />       
        </Switch>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export default App;
